module.exports = global.EventSource;



//////////////////
// WEBPACK FOOTER
// P:/Work/htdocs/biatlon/online/~/sockjs-client/lib/transport/browser/eventsource.js
// module id = 304
// module chunks = 0